import { IInvoiceSituationDTO, IPartialPaymentsByInvoice } from "@/interface"
import { DateHelper } from "@/mega-ui/helpers/function"

export class InvoiceSituation {
    public openInvoiceTotal: number;
    public isInDebt: boolean;
    public firstInvoiceDueDate: Date|null;
    public firstInvoiceIssueDate: Date|null;
    public nextInvoiceDate: Date|null;
    public nextInvoiceDueDate: Date|null;
    public payUrgently: boolean;
    public partialPayments: IPartialPaymentsByInvoice;

    constructor(base: InvoiceSituation) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IInvoiceSituationDTO):InvoiceSituation | null {
        if (!dto) {
            return null;
        }
        
        return new InvoiceSituation({
            openInvoiceTotal: dto.total_open_incl_vat ? Math.abs(+dto.total_open_incl_vat) : 0,
            isInDebt: !isNaN(+dto.total_open_incl_vat) && parseFloat(dto.total_open_incl_vat) < 0,
            firstInvoiceDueDate: dto.first_open_invoice_due_date ? new Date(dto.first_open_invoice_due_date) : null,
            firstInvoiceIssueDate: dto.first_open_invoice_issue_date ? new Date(dto.first_open_invoice_issue_date) : null,
            nextInvoiceDate: dto.next_invoice_issue_date ? new Date(dto.next_invoice_issue_date) : null,
            nextInvoiceDueDate: dto.next_invoice_due_date ? new Date(dto.next_invoice_due_date) : null,
            partialPayments: dto.partial_payments_by_invoice,
            payUrgently: dto.first_open_invoice_due_date ? DateHelper.isAfterOrSame(new Date(), new Date(dto.first_open_invoice_due_date)) && parseFloat(dto.total_open_incl_vat) < 0 : false
        });
    }
}
